import {useEffect, useState} from 'react';
import {withRouterWrapper, WithRouterWrapperProps, Marina} from 'marine-panel-common-web';
import {Card} from 'reactstrap';
import LayoutWrapper from '../../LayoutWrapper';
import marinaMenu from './WizardHost/edit-menu-items';
import SideNavigation from './WizardHost/SideNavigation';
import HostRouting from './WizardHost/HostRouting';
import {useParams} from 'react-router-dom';
import {marinasSelector} from '../../../store/selectors/marinaSelectors';
import {RootState} from '../../../store/reducers';
import {connect} from 'react-redux';
import {currentlyEditedMarina} from '../../../store/selectors/marinaEditWizardSelectors';
import EditItemBadges from './WizardHost/Badges';

export const enum WizardEditHostType {
    MARINA = 'marina',
    BERTH = 'berth',
}

export interface IEditItemHostProps extends WithRouterWrapperProps {
    readonly editedItemType: WizardEditHostType;
    readonly marina: Marina | null;
    readonly marinas: Marina[];
}

const WizardEdit = (props: IEditItemHostProps) => {
    const [activeSublink, setActiveSubmenu] = useState('');
    const [editedMarina, setActiveMarina] = useState<Marina | undefined>(undefined);
    const itemTitle = editedMarina?.name || '',
        sideMenuConfig = marinaMenu,
        location = props.router.location;
    const params = useParams();
    useEffect(() => {
        const locationId = location.hash ? location.hash.slice(1) : '';
        if (activeSublink !== locationId) {
            setActiveSubmenu(locationId);
        }
    }, [activeSublink, location]);

    useEffect(() => {
        if (params && params.id) {
            if (props.editedItemType === WizardEditHostType.MARINA && props.marina) {
                setActiveMarina(props.marina);
            }
        }
    }, [props.editedItemType, props.marina]);

    return (
        <LayoutWrapper>
            <Card className="wizard-edit-host-card">
                <section className="wizard-edit-host-wrapper">
                    <div className="wizard-edit-host-header" data-header>
                        <h3 className="wizard-edit-title">{itemTitle}</h3>
                        <EditItemBadges marina={editedMarina} />
                    </div>
                    <div className="wizard-edit-host-content row">
                        <SideNavigation sideMenuConfig={sideMenuConfig()} activeSublink={activeSublink} />
                        <HostRouting
                            sideMenuConfig={sideMenuConfig()}
                            activeSublink={activeSublink}
                            onSubmenuChanged={(submenuId: string) => setActiveSubmenu(submenuId)}
                        />
                    </div>
                </section>
            </Card>
        </LayoutWrapper>
    );
};

export default connect(
    (state: RootState) => ({
        marina: currentlyEditedMarina(state),
        marinas: marinasSelector(state),
    }),
    {}
)(withRouterWrapper(WizardEdit));
